import { render, staticRenderFns } from "./StrongsPage.vue?vue&type=template&id=052823d9&scoped=true&"
import script from "./StrongsPage.vue?vue&type=script&lang=js&"
export * from "./StrongsPage.vue?vue&type=script&lang=js&"
import style0 from "./StrongsPage.vue?vue&type=style&index=0&id=052823d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052823d9",
  null
  
)

export default component.exports